import { PointsAction } from "@t3/shared";

export const getRefundProductDetails = (action: PointsAction) => {
  const images: string[] = [];
  const products: Array<{
    name: string;
    image?: string;
    type?: string;
    status?: string;
  }> = [];

  if (action.type === "refund" && action.typeMeta.purchaseResults) {
    const { tangoPurchaseResults, travelPurchaseResults, zincPurchaseResults } =
      action.typeMeta.purchaseResults;

    if (tangoPurchaseResults) {
      Object.values(tangoPurchaseResults).forEach((results: any) => {
        results.forEach((result: any) => {
          const imageUrl =
            result.tangoProduct?.metadata?.imageUrls?.["300w-326ppi"];
          if (imageUrl) {
            images.push(imageUrl);
          }
          products.push({
            name: result.tangoProduct?.metadata?.brandName || "Product",
            image: imageUrl,
            type: "tango",
            status: result.status,
          });
        });
      });
    }

    if (travelPurchaseResults) {
      Object.values(travelPurchaseResults).forEach((results: any) => {
        results.forEach((result: any) => {
          const imageUrl =
            result.travelProduct?.metadata?.imageUrls?.firebaseImage;
          if (imageUrl) {
            images.push(imageUrl);
          }
          products.push({
            name: result.travelProduct?.metadata?.brandName || "Travel Product",
            image: imageUrl,
            type: "travel",
            status: result.status,
          });
        });
      });
    }

    if (zincPurchaseResults) {
      zincPurchaseResults.forEach((result: any) => {
        result.zincProducts?.forEach((product: any) => {
          if (product.image) {
            images.push(product.image);
          }

          // Determine status based on orderData (matching CartHistoryZincItem logic)
          let displayStatus: string;

          if (!result.orderData) {
            // No orderData means still processing
            displayStatus = "processing";
          } else if (result.orderData.responseType === "error") {
            // Error response
            displayStatus = "error";
          } else if (result.orderData.responseType === "order_response") {
            // Check for delivery tracking status first
            const trackingForProduct = result.orderData.trackingInfo?.find(
              (tracking: any) =>
                tracking.product_ids.includes(product.product_id),
            );
            displayStatus =
              trackingForProduct?.delivery_status || "order placed";
          } else {
            // Fallback to purchase result status
            displayStatus = result.status;
          }

          products.push({
            name: product.title || result.productTitle || "Product",
            image: product.image,
            type: "zinc",
            status: displayStatus,
          });
        });
      });
    }
  }

  return { images, products, totalCount: products.length };
};
